import $ from "../core/jquery-global";

export function initAnimations({ Waypoint, CountUp }) {
    if (!$(".js_anim").length) {
        return;
    }

    if (!Waypoint) {
        console.error("Waypoint non trovato");
        return;
    }

    setTimeout(function () {
        $(".js_anim").each(function (index, el) {
            new Waypoint({
                element: el,
                handler: function (direction) {
                    if (direction === "down" && $(el).find(".js_anim_child").length) {
                        $(el)
                            .find(".js_anim_child")
                            .each(function (index, childel) {
                                animStart(childel);

                                var $childEl = $(childel);
                                var callback = $childEl.attr("data-anim-callback");
                                var time = $childEl.attr("data-anim-delay");

                                if (typeof time !== "undefined" && time !== false) {
                                    setTimeout(function () {
                                        animCallback(callback, childel);
                                        animEnd(childel);
                                    }, parseInt(time, 10));
                                } else {
                                    animCallback(callback, childel);
                                    animEnd(childel);
                                }
                            });
                    }
                },
                offset: "200px"
            });
        });
    }, 1200);

    function animCallback(callback, el) {
        if (callback !== "numberCount") {
            return;
        }

        var rawNumber = el.dataset.number;

        if (!CountUp) {
            console.error("CountUp non trovato");
            return;
        }

        var numericValue = Number(rawNumber);

        if (isNaN(numericValue)) {
            console.error("Valore non valido:", rawNumber);
            return;
        }

        var decimalPlaces = 0;
        if (rawNumber.includes(".")) {
            decimalPlaces = rawNumber.split(".")[1].length;
        }

        var options = {
            useGrouping: true,
            separator: ".",
            decimal: ".",
            decimalPlaces: decimalPlaces
        };

        var c = new CountUp(el, numericValue, options);

        if (c.error) {
            console.error(c.error);
            return;
        }

        c.start();
    }

    function animStart(el) {
        $(el).addClass("is_anim");
    }

    function animEnd(el) {
        $(el).removeClass("is_anim");
        $(el).addClass("is_anim_finished");
    }
}
